import React from "react";
import { Link } from "react-router-dom";
import "./PublicFooter.css";

const PublicFooter: React.FC = () => {
  return (
    <footer className="public-footer">
      <div className="public-footer-container">
        <p className="public-footer-text">
          © 2025 CosaVorrei di Luca Mattivi - P.IVA 02600330225 - Giovo (TN) -{" "}
          <a href="mailto:info@cosavorrei.it" className="public-footer-link">
            info@cosavorrei.it
          </a>
        </p>
        <nav className="public-footer-nav">
          <Link to="/come-funziona" className="public-footer-link">
            Come Funziona
          </Link>
          <span className="public-footer-separator">•</span>
          <Link to="/faq" className="public-footer-link">
            FAQ
          </Link>
          <span className="public-footer-separator">•</span>
          <Link to="/privacy" className="public-footer-link">
            Privacy
          </Link>
          <span className="public-footer-separator">•</span>
          <Link to="/termini" className="public-footer-link">
            Termini
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default PublicFooter;
